// app相关页面
export default [
  {
    path: '/howtolearn',
    name: 'howtolearn',
    component: resolve => require(['@/pages/app/howtolearn'], resolve)
  },
  {
    path: '/activity/3dword',
    name: '3dword',
    component: resolve => require(['@/pages/app/word3d'], resolve)
  },
  {
    path: '/aboutus',
    name: 'aboutus',
    component: resolve => require(['@/pages/app/aboutus'], resolve)
  },
  {
    path: '/activity/arreport',
    component: resolve => require(['@/pages/app/arshare.vue'], resolve)
  },
  {
    path: '/activity/freeewordreport',
    component: resolve => require(['@/pages/app/freeword.vue'], resolve)
  },
  {
    path: '/activity/speakgamereport',
    component: resolve => require(['@/pages/app/speakgame.vue'], resolve)
  }
]
